import api from './api';

export interface NewsletterResponse {
    success: boolean;
    message: string;
    data?: unknown;
}

export const newsletterAPI = {
    // Subscribe to newsletter
    subscribe: async (email: string): Promise<NewsletterResponse> => {
        const response = await api.post('/newsletter/subscribe', { email });
        return response.data;
    },

    // Unsubscribe from newsletter
    unsubscribe: async (email: string): Promise<NewsletterResponse> => {
        const response = await api.post('/newsletter/unsubscribe', { email });
        return response.data;
    },

    // Get all subscribers (admin only)
    getAllSubscribers: async (active?: boolean): Promise<NewsletterResponse> => {
        const params = active !== undefined ? { active } : {};
        const response = await api.get('/newsletter', { params });
        return response.data;
    },

    // Delete subscriber (admin only)
    deleteSubscriber: async (id: string): Promise<NewsletterResponse> => {
        const response = await api.delete(`/newsletter/${id}`);
        return response.data;
    }
};

export default newsletterAPI;
